import { Form, Formik } from 'formik';
import { useMemo } from 'react';
import { Grid } from '@mui/material';

import { FormPart } from '@modules/shared/components/FormPart';
import { Modal } from '@shared/components/modals/Modal';
import { CheckboxField } from '@shared/fields/CheckboxField';
import { NumberInputField } from '@shared/fields/NumberInputField';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { ModalFormFooter } from '@styles/ModalStyles';

import { ILeadSourceConfigurationForm } from './LeadSourceConfiguration';
import { leadConfigValidationSchema } from './validation';


interface ILeadConfigurationModalProps {
    open                     : boolean;
    currentLeadConfiguration : ILeadSourceConfigurationForm | null;
    currentLeadConfigurationPosition: number;
    handleClose              : () => void;
    handleSubmit             : (data: ILeadSourceConfigurationForm) => void;
}
export const LeadConfigurationModal = ({
  open,
  currentLeadConfiguration,
  currentLeadConfigurationPosition,
  handleClose,
  handleSubmit,
}: ILeadConfigurationModalProps) => {
  const initialValues = useMemo<ILeadSourceConfigurationForm>(() => ({
    id                                      : currentLeadConfiguration?.id || '',
    autoResponseVersion                     : currentLeadConfiguration?.autoResponseVersion || 1,
    source                                  : currentLeadConfiguration?.source || '',
    name                                    : currentLeadConfiguration?.name || '',
    numericId                               : currentLeadConfiguration?.numericId || '',
    description                             : currentLeadConfiguration?.description || '',
    autoResponsePostUrl                     : currentLeadConfiguration?.autoResponsePostUrl || '',
    autoDeadDelayedResponse                 : currentLeadConfiguration?.autoDeadDelayedResponse || '',
    autoDelayedResponseOfferCallbackBaseUrl : currentLeadConfiguration?.autoDelayedResponseOfferCallbackBaseUrl || '',
    customerPortalUrl                       : currentLeadConfiguration?.customerPortalUrl || '',
    allowSecondary                          : currentLeadConfiguration?.allowSecondary || false,
    isSecondary                             : currentLeadConfiguration?.isSecondary || false,
    isAutoResponseEnabled                   : currentLeadConfiguration?.isAutoResponseEnabled || false,
    isAutoDeadEnabled                       : currentLeadConfiguration?.isAutoDeadEnabled || false,
    enableCamRef                            : currentLeadConfiguration?.enableCamRef || false,
    isAutoDelayedResponseEnabled            : currentLeadConfiguration?.isAutoDelayedResponseEnabled || false,
  }), [currentLeadConfiguration]);

  const formConfig = [
    { name: 'name', label: 'Source Name' },
    { name: 'numericId', pattern: /^\d*$/ },
    { name: 'description' },
    { name: 'autoResponsePostUrl' },
    { name: 'autoDeadDelayedResponse', decimalScale: 2, component: NumberInputField },
    { name: 'autoDelayedResponseOfferCallbackBaseUrl' },
    { name: 'customerPortalUrl' },
    { name: 'allowSecondary', component: CheckboxField },
    { name: 'isSecondary', component: CheckboxField }, 
    { name: 'isAutoResponseEnabled', component: CheckboxField }, 
    { name: 'isAutoDeadEnabled', component: CheckboxField }, 
    { name: 'enableCamRef', component: CheckboxField }, 
    { name: 'isAutoDelayedResponseEnabled', component: CheckboxField }].map((field) => ({
        ...field,
        editable: false,
        width: '50%',
    }),
  );

  return (
    <Modal
      hideBackdrop
      title="Add New Lead Source"
      dialogWidth = "50vw"
      open        = {open}
      resetPosition={currentLeadConfigurationPosition}
      onClose     = {handleClose}
    >
      <Formik
        validateOnChange
        enableReinitialize
        initialValues    = {initialValues}
        validationSchema = {leadConfigValidationSchema}
        onSubmit         = {handleSubmit}
      >
        <Form>
          <>
            <Grid container spacing={12}>
              <Grid item md={12}>
                <FormPart config={formConfig} />
              </Grid>
            </Grid>

            <ModalFormFooter>
              <CancelButton onClick={handleClose} />
                  <SaveButton />
            </ModalFormFooter>
          </> 
        </Form>
      </Formik>
    </Modal>
  );
};
